import ApiClient from '../../../helpers/apiClient';

export const FETCH_ANALYTICS_EVENT_DAILY_REQUEST = 'FETCH_ANALYTICS_EVENT_DAILY_REQUEST';
export const FETCH_ANALYTICS_EVENT_DAILY_SUCCESS = 'FETCH_ANALYTICS_EVENT_DAILY_SUCCESS';
export const FETCH_ANALYTICS_EVENT_DAILY_ERROR = 'FETCH_ANALYTICS_EVENT_DAILY_ERROR';

export const fetchAnalyticsEventDaily = (startDate, endDate) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_ANALYTICS_EVENT_DAILY_REQUEST,
        FETCH_ANALYTICS_EVENT_DAILY_SUCCESS,
        FETCH_ANALYTICS_EVENT_DAILY_ERROR,
      ],
      callAPI: () =>
        ApiClient.get('network/AnalyticsEventDaily/GetDaily', {
          params: { startDate, endDate },
        }),
      payload: { startDate, endDate },
    }),
  );
};

export const FETCH_ANALYTICS_CLICKS_REQUEST = 'FETCH_ANALYTICS_CLICKS_REQUEST';
export const FETCH_ANALYTICS_CLICKS_SUCCESS = 'FETCH_ANALYTICS_CLICKS_SUCCESS';
export const FETCH_ANALYTICS_CLICKS_ERROR = 'FETCH_ANALYTICS_CLICKS_ERROR';

export const FETCH_ANALYTICS_USERS_REQUEST = 'FETCH_ANALYTICS_USERS_REQUEST';
export const FETCH_ANALYTICS_USERS_SUCCESS = 'FETCH_ANALYTICS_USERS_SUCCESS';
export const FETCH_ANALYTICS_USERS_ERROR = 'FETCH_ANALYTICS_USERS_ERROR';

export const fetchAnalyticsUsers = (startDate, endDate) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_ANALYTICS_USERS_REQUEST, FETCH_ANALYTICS_USERS_SUCCESS, FETCH_ANALYTICS_USERS_ERROR],
      callAPI: () =>
        ApiClient.get('network/AnalyticsEventDaily/GetUsers', {
          params: { startDate, endDate },
        }),
      payload: { startDate, endDate },
    }),
  );
};

export const FETCH_ANALYTICS_USER_EVENTS_REQUEST = 'FETCH_ANALYTICS_USER_EVENTS_REQUEST';
export const FETCH_ANALYTICS_USER_EVENTS_SUCCESS = 'FETCH_ANALYTICS_USER_EVENTS_SUCCESS';
export const FETCH_ANALYTICS_USER_EVENTS_ERROR = 'FETCH_ANALYTICS_USER_EVENTS_ERROR';

export const fetchAnalyticsUserEvents = (startDate, endDate) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_ANALYTICS_USER_EVENTS_REQUEST,
        FETCH_ANALYTICS_USER_EVENTS_SUCCESS,
        FETCH_ANALYTICS_USER_EVENTS_ERROR,
      ],
      callAPI: () =>
        ApiClient.get('network/AnalyticsEventDaily/GetUserEvents', {
          params: { startDate, endDate },
        }),
      payload: { startDate, endDate },
    }),
  );
};

export const FETCH_ANALYTICS_USER_CLICKS_REQUEST = 'FETCH_ANALYTICS_USER_CLICKS_REQUEST';
export const FETCH_ANALYTICS_USER_CLICKS_SUCCESS = 'FETCH_ANALYTICS_USER_CLICKS_SUCCESS';
export const FETCH_ANALYTICS_USER_CLICKS_ERROR = 'FETCH_ANALYTICS_USER_CLICKS_ERROR';

export const fetchAnalyticsUserClicks = (startDate, endDate) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_ANALYTICS_USER_CLICKS_REQUEST,
        FETCH_ANALYTICS_USER_CLICKS_SUCCESS,
        FETCH_ANALYTICS_USER_CLICKS_ERROR,
      ],
      callAPI: () =>
        ApiClient.get('network/AnalyticsEventDaily/GetUserClicks', {
          params: { startDate, endDate },
        }),
      payload: { startDate, endDate },
    }),
  );
};

export const fetchAnalyticsClicks = (startDate, endDate) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_ANALYTICS_CLICKS_REQUEST, FETCH_ANALYTICS_CLICKS_SUCCESS, FETCH_ANALYTICS_CLICKS_ERROR],
      callAPI: () =>
        ApiClient.get('network/AnalyticsEventDaily/GetClicks', {
          params: { startDate, endDate },
        }),
      payload: { startDate, endDate },
    }),
  );
};

const initialState = {
  payload: {},
  data: {},
  response: {},
  error: {},
  errorMessage: '',
  successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case FETCH_ANALYTICS_EVENT_DAILY_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_ANALYTICS_EVENT_DAILY_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response?.data?.data || [],
        },
        response,
        successMessage,
      };

    case FETCH_ANALYTICS_EVENT_DAILY_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
